import * as React from "react";
import { COLOR } from "../../utils/variables";
var MenuItem = function (props) {
    var navActiveStyle = {
        background: props.activeBgColor ? props.activeBgColor : COLOR.LIGHT_ORANGE,
        color: props.activeColor ? props.activeColor : COLOR.BUTTON_PRIMARY,
        borderLeft: "4px solid ".concat(props.activeColor ? props.activeColor : COLOR.BUTTON_PRIMARY)
    };
    return React.createElement("div", { className: "nav-container ".concat(props.menu.active ? "active" : "inactive"), style: props.menu.active ? navActiveStyle : {}, onClick: function () { return props.onMenuChange(props.menu); } },
        props.menu.icon && React.createElement("img", { className: "menu-icon", src: props.menu.icon, alt: props.menu.name }),
        props.menu.name && React.createElement("p", { className: "menu-name", style: props.menu.active ?
                { color: props.activeColor ? props.activeColor : COLOR.BUTTON_PRIMARY } :
                { color: props.color ? props.color : COLOR.PRIMARY_GREY } }, props.menu.name));
};
export default MenuItem;
//# sourceMappingURL=index.js.map